export default "__VITE_ASSET__COjYb3tD__"